<template>
  <div class="card shadow bg-secondary">
    <div class="card-header border-0">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white' : ''">
            {{ title }}
          </h3>
        </div>
      </div>
    </div>

    <div class="card-body pt-0 pt-md-4">
      <h6 class="heading-small text-muted mb-4">บันทึกข้อมูลกรมธรรม์</h6>
      <div class="row">
        <div class="col-12 col-md-3">
          <base-input
            alternative=""
            label="กรมธรรมเลขที่"
            placeholder="กรมธรรมเลขที่"
            input-classes="form-control-alternative"
            v-model="model.policy_number"
            @input="
              (v) => {
                model.policy_number = v.toUpperCase();
              }
            "
          />
        </div>
        <div class="col-12 col-md-3">
          <h4>ตัวแทน</h4>
          <div class="dropdown">
            <b-dropdown
              id="dropdown"
              offset="100"
              :text="
                selectedAgent !== -1
                  ? masterAgent[selectedAgent].name
                  : '-- กรุณาเลือก --'
              "
              class="m-0 mr-2"
            >
              <b-dropdown-item
                v-for="(agent, index) in masterAgent"
                :key="agent.id"
                :value="agent.name"
                @click="selectAgent(agent.id, index)"
                >{{ agent.name }}</b-dropdown-item
              >
            </b-dropdown>
          </div>
        </div>
        <div class="col-12 col-md-3">
          <h4>บริษัท</h4>
          <div class="dropdown">
            <b-dropdown
              id="dropdown"
              offset="100"
              :text="
                selectedCompany !== -1
                  ? masterCompany[selectedCompany].name
                  : '-- กรุณาเลือก --'
              "
              class="m-0 mr-2"
            >
              <b-dropdown-item
                v-for="(company, index) in masterCompany"
                :key="company.id"
                :value="company.name"
                @click="selectCompany(company.id, index)"
                >{{ company.name }}</b-dropdown-item
              >
            </b-dropdown>
          </div>
        </div>
        <div class="col-12 col-md-3">
          <div>
            <label for="file" class="form-control-label"
              >อัพโหลดไฟล์กรมธรรม์</label
            >
          </div>
          <input
            type="file"
            id="file"
            name="file"
            ref="file"
            accept="image/pdf, image/png , image/jpg , image/jpeg"
            @change="onFileChange"
          />
        </div>
      </div>
      <h6 class="heading-small text-muted mb-4 mt-4">รายละเอียดลูกค้า</h6>
      <div class="row">
        <div class="col-md-2">
          <base-input
            ref="name_prefix"
            alternative=""
            label="คำนำหน้า"
            placeholder="คำนำหน้า"
            input-classes="form-control-alternative"
            v-model="model.name_prefix"
          />
        </div>
        <div class="col-md-6">
          <!-- <base-input
            alternative=""
            label="ชื่อ-นามสกุล"
            placeholder="ชื่อ-นามสกุล"
            input-classes="form-control-alternative"
            v-model="model.name"
          /> -->
          <strong><label>ชื่อ-นามสกุล</label></strong>
          <vue-suggestion
            ref="name"
            :items="items"
            v-model="item"
            :minLen="minLen"
            :maxLen="maxLen"
            :setLabel="setLabel"
            placeholder="ชื่อ-นามสกุล"
            class="form-control form-control-alternative"
            :itemTemplate="itemTemplate"
            @changed="inputChange"
            @selected="itemSelected"
          >
          </vue-suggestion>
        </div>
        <div class="col-md-4">
          <base-input
            alternative=""
            label="เลขที่บัตรประจำตัว/เลขจดทะเบียนบริษัท"
            type="number"
            placeholder="เลขที่บัตรประจำตัว/เลขจดทะเบียนบริษัท"
            input-classes="form-control-alternative"
            v-model="model.identity_no"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-12  col-md-9">
          <base-input
            alternative=""
            label="ที่อยู่"
            placeholder="ที่อยู่"
            input-classes="form-control-alternative"
            v-model="model.address"
          />
        </div>
        <div class="col-12 col-md-3">
          <base-input
            ref="tel"
            alternative=""
            label="เบอร์โทรศัพท์"
            type="number"
            placeholder="เบอร์โทรศัพท์"
            input-classes="form-control-alternative"
            v-model="model.tel"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-3">
          <h4>จังหวัด</h4>
          <v-select
            v-model="model.province"
            :options="masterProvince"
            :reduce="(p) => p.id"
            label="name"
          ></v-select>
          <!-- <div class="dropdown">
            <b-dropdown
              id="dropdown"
              offset="100"
              :text="
                selectedProvince !== -1
                  ? masterProvince[selectedProvince].name
                  : '-- กรุณาเลือก --'
              "
              class="m-0 mr-2"
            >
              <b-dropdown-item
                v-for="(province, index) in masterProvince"
                :key="province.id"
                :value="province.name"
                @click="selectProvince(province.id, index)"
                >{{ province.name }}</b-dropdown-item
              >
            </b-dropdown>
          </div> -->
        </div>
        <div class="col-md-3 mt-3 mt-md-0">
          <h4>อำเภอ</h4>
          <v-select
            v-model="model.district"
            :options="masterDistrict"
            :reduce="(p) => p.id"
            label="name"
          ></v-select>
          <!-- <div class="dropdown w-100">
            <b-dropdown
              id="dropdown"
              offset="100"
              :text="
                selectedDistrict !== -1
                  ? masterDistrict[selectedDistrict].name
                  : '-- กรุณาเลือก --'
              "
              class="m-0 mr-2"
            >
              <b-dropdown-item
                v-for="(district, index) in masterDistrict"
                :key="district.id"
                :value="district.name"
                @click="selectDistrict(district.id, index)"
                >{{ district.name }}</b-dropdown-item
              >
            </b-dropdown>
          </div> -->
        </div>
        <div class="col-md-3 mt-3 mt-md-0">
          <h4>ตำบล</h4>
          <v-select
            v-model="model.sub_district"
            :options="masterSubDistrict"
            :reduce="(p) => p.id"
            label="name"
          ></v-select>
          <!-- <div class="dropdown w-100">
            <b-dropdown
              id="dropdown"
              offset="100"
              :text="
                selectedSubDistrict !== -1
                  ? masterSubDistrict[selectedSubDistrict].name
                  : '-- กรุณาเลือก --'
              "
              class="m-0 mr-2"
            >
              <b-dropdown-item
                v-for="(subdistrict, index) in masterSubDistrict"
                :key="subdistrict.id"
                :value="subdistrict.name"
                @click="selectSubDistrict(subdistrict.id, index)"
                >{{ subdistrict.name }}</b-dropdown-item
              >
            </b-dropdown>
          </div> -->
        </div>
        <div class="col-md-3 mt-3 mt-md-0">
          <base-input
            alternative=""
            label="รหัสไปรษณีย์"
            type="number"
            placeholder="รหัสไปรษณีย์"
            input-classes="form-control-alternative"
            v-model="model.postal_code"
          />
        </div>
      </div>
      <h6 class="heading-small text-muted mb-4 mt-4">
        รายละเอียดการเอาประกัน และเบี้ยประกันภัย ภาคบังคับ (พรบ.)
      </h6>
      <div class="row">
        <div class="col-md-3 mt-3 mt-md-0">
          <!-- <h4>วันที่คุ้มครอง</h4>
          <datepicker
            :lang="th"
            :format="momentFormat"
            class="date-picker"
            v-model="model.cover_start_date"
          ></datepicker> -->
          <base-input
            alternative=""
            label="วันที่คุ้มครอง"
            type="text"
            placeholder="วว/ดด/ปปปป"
            input-classes="form-control-alternative"
            v-model="formattedStartCoverDate"
          />
        </div>
        <div class="col-md-3 mt-3 mt-md-0">
          <!-- <h4>ถึง</h4>
          <datepicker
            :lang="th"
            :format="momentFormat"
            class="date-picker"
            placeholder="คลิกเพื่อเลือกวัน"
            v-model="model.cover_end_date"
          ></datepicker> -->
          <base-input
            ref="cover_end_date"
            alternative=""
            label="ถึง"
            type="text"
            placeholder="วว/ดด/ปปปป"
            input-classes="form-control-alternative"
            v-model="formattedEndCoverDate"
          />
        </div>
        <div class="col-md-3 mt-3 mt-md-0">
          <base-input
            alternative=""
            label="จำนวนวันคุ้มครอง"
            type="number"
            placeholder="จำนวนวันคุ้มครอง"
            input-classes="form-control-alternative"
            :value="calculateDateDiff"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-2 mt-3 mt-md-0">
          <h4>ยี่ห้อ</h4>
          <div class="dropdown">
            <b-dropdown
              id="dropdown"
              offset="100"
              :text="
                selectedBrand !== -1
                  ? masterBrand[selectedBrand].name
                  : '-- กรุณาเลือก --'
              "
              class="m-0 mr-2"
            >
              <b-dropdown-item
                v-for="(brand, index) in masterBrand"
                :key="brand.id"
                :value="brand.name"
                @click="selectBrand(brand.id, index)"
                >{{ brand.name }}</b-dropdown-item
              >
            </b-dropdown>
          </div>
        </div>
        <div class="col-12 col-md-2 mt-3 mt-md-0">
          <base-input
            alternative=""
            label="รุ่นรถ"
            placeholder="รุ่นรถ"
            input-classes="form-control-alternative"
            v-model="model.car_model"
          />
        </div>
        <div class="col-12 col-md-1 mt-3 mt-md-0">
          <base-input
            ref="car_year"
            alternative=""
            label="ปีรถ"
            placeholder="ปีรถ"
            input-classes="form-control-alternative"
            v-model="model.car_year"
          />
        </div>
        <div class="col-12 col-md-2 mt-3 mt-md-0">
          <base-input
            ref="license_plate"
            alternative=""
            label="เลขทะเบียน"
            placeholder="เลขทะเบียน"
            input-classes="form-control-alternative"
            v-model="model.license_plate"
          />
        </div>
        <div class="col-12 col-md-3">
          <h4>จังหวัด</h4>
          <v-select
            v-model="model.license_plate_province"
            :options="masterProvince"
            :reduce="(p) => p.id"
            label="name"
          ></v-select>
          <!-- <div class="dropdown">
            <b-dropdown
              id="dropdown"
              offset="100"
              :text="
                selectedLicensePlateProvince !== -1
                  ? masterProvince[selectedLicensePlateProvince].name
                  : '-- กรุณาเลือก --'
              "
              class="m-0 mr-2"
            >
              <b-dropdown-item
                v-for="(province, index) in masterProvince"
                :key="province.id"
                :value="province.name"
                @click="selectLicensePlateProvince(province.id, index)"
                >{{ province.name }}</b-dropdown-item
              >
            </b-dropdown>
          </div> -->
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-12 col-md-2 mt-3 mt-md-0">
          <h4>รหัสใช้งานรถ</h4>
          <div class="dropdown">
            <b-dropdown
              id="dropdown"
              offset="100"
              :text="
                selectedCarCode !== -1
                  ? masterCarCode[selectedCarCode].name
                  : '-- กรุณาเลือก --'
              "
              class="m-0 mr-2 car-code"
            >
              <b-dropdown-item
                v-for="(carCode, index) in masterCarCode"
                :key="carCode.id"
                :value="carCode.name"
                @click="selectCarCode(carCode.id, index)"
                >{{ carCode.name }}</b-dropdown-item
              >
            </b-dropdown>
          </div>
        </div>
        <div class="col-md-2 col-6">
          <base-input
            alternative=""
            label="อื่นๆ"
            placeholder="โปรดระบุ"
            :disabled="model.car_code !== 9"
            input-classes="form-control-alternative"
            v-model="model.if_other_car_code"
          />
        </div>
        <div class="col-2">
          <base-input
            alternative=""
            label="เลขตัวถัง"
            placeholder="เลขตัวถัง"
            input-classes="form-control-alternative"
            v-model="model.body_number"
            @input="
              (v) => {
                model.body_number = v.toUpperCase();
              }
            "
          />
        </div>
        <div class="col-md-3 col-6">
          <h4>แบบตัวถัง</h4>
          <div class="dropdown">
            <b-dropdown
              id="dropdown"
              offset="100"
              :text="
                selectedBodyType !== -1
                  ? masterBodyType[selectedBodyType].name
                  : '-- กรุณาเลือก --'
              "
              class="m-0 mr-2"
            >
              <b-dropdown-item
                v-for="(bodyType, index) in masterBodyType"
                :key="bodyType.id"
                :value="bodyType.name"
                @click="selectBodyType(bodyType.id, index)"
                >{{ bodyType.name }}</b-dropdown-item
              >
            </b-dropdown>
          </div>
        </div>
        <div class="col-md-3 col-6">
          <base-input
            alternative=""
            label="อื่นๆ"
            placeholder="โปรดระบุ"
            :disabled="model.body_type !== 4"
            input-classes="form-control-alternative"
            v-model="model.if_other_body_type"
          />
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-md-4 col-6">
          <base-input
            alternative=""
            label="CC"
            placeholder="CC"
            input-classes="form-control-alternative"
            v-model="model.cc"
          />
        </div>
        <div class="col-md-4 col-6">
          <base-input
            alternative=""
            label="ที่นั่ง"
            placeholder="ที่นั่ง"
            input-classes="form-control-alternative"
            v-model="model.seat"
          />
        </div>
        <div class="col-md-4 col-6">
          <base-input
            alternative=""
            label="น้ำหนัก"
            placeholder="น้ำหนัก"
            input-classes="form-control-alternative"
            v-model="model.weight"
          />
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-md-2 col-6">
          <h4>ประเภทประกัน</h4>
          <div class="dropdown">
            <b-dropdown
              id="dropdown"
              offset="100"
              :text="
                selectedInsuranceType !== -1
                  ? masterInsuranceType[selectedInsuranceType].name
                  : '-- กรุณาเลือก --'
              "
              class="m-0 mr-2"
            >
              <b-dropdown-item
                v-for="(type, index) in masterInsuranceType"
                :key="type.id"
                :value="type.name"
                @click="selectInsuranceType(type.id, index)"
                >{{ type.name }}</b-dropdown-item
              >
            </b-dropdown>
          </div>
        </div>
        <div class="col-md-3 col-6">
          <base-input
            alternative=""
            label="ทุนประกัน"
            type="number"
            step="any"
            placeholder="บาท"
            input-classes="form-control-alternative"
            v-model="model.coverage"
          />
        </div>
        <div class="col-md-3 col-6">
          <base-input
            ref="insurance_premium"
            alternative=""
            label="เบี้ยรวม"
            type="number"
            step="any"
            placeholder="บาท"
            input-classes="form-control-alternative"
            v-model="model.insurance_premium"
          />
        </div>
        <div class="col-md-3 col-6">
          <base-input
            alternative=""
            label="หมายเหตุ"
            type="text"
            placeholder="หมายเหตุ"
            input-classes="form-control-alternative"
            v-model="model.note"
          />
        </div>
        <div class="col-md-1 col-6 text-left">
          <base-button
            type="primary"
            size="md"
            class="mt-md-4"
            @click="addInsurance"
            :disabled="isSaving"
            >บันทึก</base-button
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import router from "../router";
import Dropdown from "bootstrap-vue/src/components/dropdown";
import Radio from "bootstrap-vue/src/components/form-radio";
// import Datepicker from "vue2-datepicker";
import moment from "moment";
import kickMixin from "../mixins/kickMixin";
import VueSuggestion from "vue-suggestion";
import itemTemplate from "./ItemTemplate.vue";

Vue.use(VueSuggestion);
Vue.use(Dropdown);
Vue.use(Radio);

moment.locale("th");

export default {
  name: "add-new-insurance",
  mixins: [kickMixin],
  // components: {
  //   Datepicker,
  // },
  props: {
    type: {
      type: String,
    },
    title: String,
  },
  data() {
    return {
      item: {},
      minLen: 5,
      maxLen: 50,
      searchedName: [],
      items: [],
      itemTemplate,

      isAutoComplete: false,

      isSaving: false,
      masterBrand: [],
      masterAgent: [],
      masterProvince: [],
      masterDistrict: [],
      masterSubDistrict: [],
      masterInsuranceType: [],
      masterBodyType: [],
      masterCarCode: [],
      masterCompany: [],
      selectedLicensePlateProvince: -1,
      selectedAgent: -1,
      selectedProvince: -1,
      selectedDistrict: -1,
      selectedSubDistrict: -1,
      selectedInsuranceType: -1,
      selectedBrand: -1,
      selectedBodyType: -1,
      selectedCarCode: -1,
      selectedCompany: -1,
      date1: moment(new Date())
        .add(543, "y")
        .format("D/MM/YYYY"),
      date2: moment(new Date())
        .add(543, "y")
        .format("D/MM/YYYY"),
      date3: "",
      date4: "",
      th: {
        formatLocale: {
          firstDayOfWeek: 1,
          monthsShort: [
            "ม.ค.",
            "ก.พ.",
            "มี.ค.",
            "เม.ย.",
            "พ.ค.",
            "มิ.ย.",
            "ก.ค.",
            "ส.ค.",
            "ก.ย.",
            "ต.ค.",
            "พ.ย.",
            "ธ.ค.",
          ],
          weekdaysMin: ["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."],
        },
        monthBeforeYear: true,
      },
      momentFormat: {
        stringify: (date) => {
          return date
            ? moment(date)
                .add(543, "y")
                .format("D MMM YYYY")
            : null;
        },
        parse: (value) => {
          return value
            ? moment(value, "D MMM YYYY")
                .subtract(543, "y")
                .toDate()
            : null;
        },
      },
      model: {
        policy_number: "",
        company_id: -1,
        file: "",
        tel: "",
        identity_no: "",
        name_prefix: "",
        name: "",
        address: "",
        license_plate_province: { id: -1, name: "-" },
        province: { id: -1, name: "-" },
        district: { id: -1, name: "-" },
        sub_district: { id: -1, name: "-" },
        postal_code: "",
        cover_start_date: moment().format("YYYY-MM-DD HH:MM"),
        cover_end_date: "",
        brand: 0,
        car_model: "",
        car_year: "",
        license_plate: "",
        body_number: "",
        car_code: -1,
        if_other_car_code: "",
        insurance_type: -1,
        body_type: -1,
        if_other_body_type: "",
        cc: "",
        seat: "",
        weight: "",
        coverage: "",
        insurance_premium: "",
        new_coverage: "",
        new_insurance_premium: "",
        created_by: 1,
        agent: -1,
        last_notify: "",
        last_sms: "",
        note: "",
        status: 1,
      },
    };
  },
  methods: {
    itemSelected(item) {
      this.isAutoComplete = true;
      this.model.name_prefix = item.name_prefix;
      this.model.name = item.name;
      this.model.tel = item.tel;
      this.model.identity_no = item.identity_no;
      this.model.address = item.address;
      this.model.province = item.province.id;
      this.model.district = item.district;
      this.model.sub_district = item.sub_district;

      this.selectProvince(item.province, -1);
    },
    setLabel(item) {
      return item.name;
    },
    inputChange(text) {
      this.model.name = text;
      if (text.length >= this.minLen && text.length <= this.maxLen) {
        this.searchByName(text);
      }
    },
    onFileChange() {
      this.model.file = this.$refs.file.files[0];
    },
    searchByName: function(text) {
      var localApp = this;
      axios
        .get(
          "/api/insurance/search/name" +
            "?keyword=" +
            text,
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
            },
          }
        )
        .then(function(response) {
          localApp.searchedName = response.data.data;
          localApp.items = localApp.searchedName.filter((item) =>
            item.name.includes(text)
          );
        })
        .catch(function(e) {
          console.log(e);
        });
    },
    addInsurance: function() {
      var localApp = this;
      if (
        localApp.model.name_prefix !== "" &&
        localApp.model.name !== "" &&
        localApp.model.tel !== "" &&
        localApp.model.license_plate !== "" &&
        localApp.model.cover_end_date != "" &&
        localApp.model.car_year != "" &&
        localApp.model.insurance_premium !== ""
      ) {
        localApp.isSaving = true;
        let formData = new FormData();
        for (let [key, value] of Object.entries(localApp.model)) {
          if (
            key === "cover_end_date" ||
            key === "cover_start_date" ||
            key === "last_notify" ||
            key === "last_sms"
          ) {
            // value = value.toJSON();
          }
          formData.append(key, value);
        }
        axios
          .post("/api/insurance", formData, {
            headers: {
              Authorization: "Bearer " + localStorage.token,
              "Content-Type":
                "multipart/form-data;boundary=---WebKitFormBoundary7MA4YWxkTrZu0gW",
            },
          })
          .then(function(response) {
            if (response.status == 200) {
              if (response.data.error) {
                alert(response.data.error);
              } else {
                router.push("/customerInsuranceHistory");
              }
            }
            localApp.isSaving = false;
          })
          .catch(function(error) {
            alert(error);
            localApp.isSaving = false;
          });
      } else if (this.$route.params.id) {
        localApp.isSaving = true;
        let formData = new FormData();
        for (let [key, value] of Object.entries(localApp.model)) {
          if (
            key === "cover_end_date" ||
            key === "cover_start_date" ||
            key === "last_notify" ||
            key === "last_sms"
          ) {
            // value = value.toJSON();
          }
          formData.append(key, value);
        }
        axios
          .post("/api/insurance", formData, {
            headers: {
              Authorization: "Bearer " + localStorage.token,
              "Content-Type":
                "multipart/form-data;boundary=---WebKitFormBoundary7MA4YWxkTrZu0gW",
            },
          })
          .then(function(response) {
            if (response.status == 200) {
              if (response.data.error) {
                alert(response.data.error);
              } else {
                router.push("/customerInsuranceHistory");
              }
            }
            localApp.isSaving = false;
          })
          .catch(function(error) {
            alert(error);
            localApp.isSaving = false;
          });
      } else {
        // alert(
        //   "กรุณาใส่ ชื่อ, เบอร์โทร, เลขทะเบียน, วันคุ้มครอง, วันหมดอายุ และ เบี้ยรวม"
        // );
        if (localApp.model.name_prefix == "") {
          let elm = localApp.$refs.name_prefix.$el.lastElementChild;
          elm.classList.remove("b-red");
          elm.focus();
          elm.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "nearest",
          });
          elm.classList.add("b-red");
        } else {
          let elm = localApp.$refs.name_prefix.$el.lastElementChild;
          elm.classList.remove("b-red");
        }
        if (localApp.model.name == "") {
          let elm = localApp.$refs.name.$el.lastElementChild.lastElementChild;
          localApp.$refs.name.$el.lastElementChild.classList.remove("b-red");
          elm.focus();
          elm.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "nearest",
          });
          localApp.$refs.name.$el.classList.add("b-red");
        } else {
          localApp.$refs.name.$el.classList.remove("b-red");
        }
        if (localApp.model.tel == "") {
          let elm = localApp.$refs.tel.$el.lastElementChild;
          elm.classList.remove("b-red");
          elm.focus();
          elm.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "nearest",
          });
          elm.classList.add("b-red");
        } else {
          let elm = localApp.$refs.tel.$el.lastElementChild;
          elm.classList.remove("b-red");
        }
        if (localApp.model.cover_end_date == "") {
          let elm = localApp.$refs.cover_end_date.$el.lastElementChild;
          elm.classList.remove("b-red");
          elm.focus();
          elm.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "nearest",
          });
          elm.classList.add("b-red");
        } else {
          let elm = localApp.$refs.cover_end_date.$el.lastElementChild;
          elm.classList.remove("b-red");
        }
        if (localApp.model.license_plate == "") {
          let elm = localApp.$refs.license_plate.$el.lastElementChild;
          elm.focus();
          elm.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "nearest",
          });
          elm.classList.add("b-red");
        } else {
          let elm = localApp.$refs.license_plate.$el.lastElementChild;
          elm.classList.remove("b-red");
        }
        if (localApp.model.car_year == "") {
          let elm = localApp.$refs.car_year.$el.lastElementChild;
          elm.focus();
          elm.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "nearest",
          });
          elm.classList.add("b-red");
        } else {
          let elm = localApp.$refs.car_year.$el.lastElementChild;
          elm.classList.remove("b-red");
        }
        if (localApp.model.insurance_premium == "") {
          let elm = localApp.$refs.insurance_premium.$el.lastElementChild;
          elm.focus();
          elm.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "nearest",
          });
          elm.classList.add("b-red");
        } else {
          let elm = localApp.$refs.insurance_premium.$el.lastElementChild;
          elm.classList.remove("b-red");
        }
        return;
      }
    },
    getBrand: function() {
      var localApp = this;
      axios
        .get("/api/master/brand", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            localApp.masterBrand = response.data.data;
          }
        })
        .catch(function() {
          localApp.kick();
        });
    },
    getAgent: function() {
      var localApp = this;
      axios
        .get("/api/master/agent", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            localApp.masterAgent = response.data.data;
          }
        })
        .catch(function() {
          localApp.kick();
        });
    },
    getProvince: function() {
      var localApp = this;
      axios
        .get("/api/master/province", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            localApp.masterProvince = response.data.data;
          }
        })
        .catch(function() {
          localApp.kick();
        });
    },
    getCarCode: function() {
      var localApp = this;
      axios
        .get("/api/master/carCode", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            localApp.masterCarCode = response.data.data;
          }
        })
        .catch(function() {
          localApp.kick();
        });
    },
    getInsuranceType: function() {
      var localApp = this;
      axios
        .get("/api/master/insuranceType", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            localApp.masterInsuranceType = response.data.data;
          }
        })
        .catch(function() {
          localApp.kick();
        });
    },
    getBodyType: function() {
      var localApp = this;
      axios
        .get("/api/master/bodyType", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            localApp.masterBodyType = response.data.data;
          }
        })
        .catch(function() {
          localApp.kick();
        });
    },
    getCompany: function() {
      var localApp = this;
      axios
        .get("/api/master/company", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            localApp.masterCompany = response.data.data.filter(
              (company) => !["RVP", "UD", "CPA"].includes(company.nickname)
            );
          }
        })
        .catch(function() {
          localApp.kick();
        });
    },
    selectAgent: function(id, index) {
      var localApp = this;
      localApp.selectedAgent = index;
      localApp.model.agent = id;
    },
    selectLicensePlateProvince: function(id, index) {
      var localApp = this;
      localApp.selectedLicensePlateProvince = index;
      localApp.model.license_plate_province = id;
    },
    selectProvince: function(id, index) {
      var localApp = this;
      localApp.selectedProvince = index;
      // localApp.model.province = id;

      if (!localApp.isAutoComplete && !localApp.$route.params.id) {
        localApp.model.district = { id: -1, name: "-" };
        localApp.model.sub_district = { id: -1, name: "-" };
        localApp.model.postal_code = "";
      }

      axios
        .get("/api/master/district/" + id, {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            localApp.masterDistrict = response.data.data;

            if (localApp.$route.params.id) {
              localApp.selectedDistrict = localApp.masterDistrict.findIndex(
                (item) => item.id === localApp.model.district
              );
              // localApp.selectDistrict(
              //   localApp.model.district,
              //   localApp.selectedDistrict
              // );
            }
          }
        })
        .catch(function() {
          localApp.kick();
        });
    },
    selectDistrict: function(id, index) {
      var localApp = this;
      localApp.selectedDistrict = index;
      // localApp.model.district = id;

      if (!localApp.isAutoComplete && !localApp.$route.params.id) {
        localApp.model.sub_district = { id: -1, name: "-" };
        localApp.model.postal_code = "";
      }

      axios
        .get("/api/master/subdistrict/" + id, {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            localApp.masterSubDistrict = response.data.data;

            if (localApp.$route.params.id) {
              localApp.selectedSubDistrict = localApp.masterSubDistrict.findIndex(
                (item) => item.id === localApp.model.sub_district
              );
            }
          }
        })
        .catch(function() {
          localApp.kick();
        });
    },
    selectSubDistrict: function(id, index) {
      var localApp = this;
      localApp.selectedSubDistrict = index;
      // localApp.model.sub_district = id;

      if (!localApp.isAutoComplete && !localApp.$route.params.id) {
        localApp.model.postal_code = "";
      }

      axios
        .get("/api/master/postal/" + id, {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            localApp.model.postal_code = response.data.data[0].code;
          }
          localApp.isAutoComplete = false;
        })
        .catch(function() {
          localApp.isAutoComplete = false;
          // localApp.kick();
          // alert("โปรดระบุข้อมูล จังหวัด อำเภอ และตำบล");
        });
    },
    selectBrand: function(id, index) {
      var localApp = this;
      localApp.selectedBrand = index;
      localApp.model.brand = id;
    },
    selectBodyType: function(id, index) {
      var localApp = this;
      localApp.selectedBodyType = index;
      localApp.model.body_type = id;
    },
    selectCarCode: function(id, index) {
      var localApp = this;
      localApp.selectedCarCode = index;
      localApp.model.car_code = id;
    },
    selectInsuranceType: function(id, index) {
      var localApp = this;
      localApp.selectedInsuranceType = index;
      localApp.model.insurance_type = id;
    },
    selectCompany: function(id, index) {
      var localApp = this;
      localApp.selectedCompany = index;
      localApp.model.company_id = id;
    },
    loadInsurance: function() {
      var localApp = this;
      axios
        .get("/api/insurance/" + this.$route.params.id, {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then(function(response) {
          localApp.date1 = moment(
            response.data.data.contact_start_date,
            "YYYY-MM-DD HH:MM:SS"
          )
            .add(543, "y")
            .format("DD/MM/YYYY");
          localApp.date2 = moment(
            response.data.data.cover_start_date,
            "YYYY-MM-DD HH:MM:SS"
          )
            .add(543, "y")
            .format("DD/MM/YYYY");

          // let endDateForExtend = response.data.data.cover_end_date;
          // localApp.date3 = moment(
          //   response.data.data.cover_end_date,
          //   "YYYY-MM-DD HH:MM:SS"
          // )
          //   .add(543, "y")
          //   .format("DD/MM/YYYY");
          // localApp.date4 = moment(
          //   response.data.data.tax_due_date,
          //   "YYYY-MM-DD HH:MM:SS"
          // )
          //   .add(543, "y")
          //   .format("DD/MM/YYYY");
          response.data.data.policy_number = "";
          response.data.data.company_id = -1;
          if (localApp.$route.params.id) {
            response.data.data.cover_start_date =
              response.data.data.cover_end_date;
            localApp.date2 = moment(
              response.data.data.cover_start_date,
              "YYYY-MM-DD HH:MM:SS"
            )
              .add(543, "y")
              .format("DD/MM/YYYY");
          }
          response.data.data.cover_end_date = "";
          // response.data.data.tax_due_date = "";

          // response.data.data.contact_start_date = moment(
          //   response.data.data.contact_start_date,
          //   "YYYY-MM-DD HH:MM:SS"
          // ).format("DD/MM/YYYY");
          // response.data.data.cover_start_date = moment(
          //   response.data.data.cover_start_date,
          //   "YYYY-MM-DD HH:MM:SS"
          // ).format("DD/MM/YYYY");
          // response.data.data.cover_end_date = moment(
          //   response.data.data.cover_end_date,
          //   "YYYY-MM-DD HH:MM:SS"
          // ).format("DD/MM/YYYY");
          // response.data.data.tax_due_date = moment(
          //   response.data.data.tax_due_date,
          //   "YYYY-MM-DD HH:MM:SS"
          // ).format("DD/MM/YYYY");

          response.data.data.file = "";
          response.data.data.document = "";
          localApp.model = response.data.data;

          localApp.selectedBrand = localApp.masterBrand.findIndex(
            (item) => item.id === localApp.model.brand
          );
          localApp.selectedAgent = localApp.masterAgent.findIndex(
            (item) => item.id === localApp.model.agent
          );
          localApp.selectedProvince = localApp.masterProvince.findIndex(
            (item) => item.id === localApp.model.province
          );
          localApp.selectedLicensePlateProvince = localApp.masterProvince.findIndex(
            (item) => item.id === localApp.model.license_plate_province
          );
          localApp.selectedCarCode = localApp.masterCarCode.findIndex(
            (item) => item.id === localApp.model.car_code
          );
          localApp.selectedBodyType = localApp.masterBodyType.findIndex(
            (item) => item.id === localApp.model.body_type
          );
          // localApp.selectedCompany = localApp.masterCompany.findIndex(
          //   (item) => item.id === localApp.model.company_id
          // );
          localApp.selectedInsuranceType = localApp.masterInsuranceType.findIndex(
            (item) => item.id === localApp.model.insurance_type
          );

          localApp.selectProvince(
            localApp.model.province,
            localApp.selectedProvince
          );

          if (localApp.$route.params.id) {
            localApp.model.old_id = localApp.$route.params.id;
            // localApp.loadLatestPremium(localApp.$route.params.id);
            localApp.model.coverage = localApp.model.new_coverage;
            localApp.model.insurance_premium =
              localApp.model.new_insurance_premium;
            localApp.model.new_coverage = 0;
            localApp.model.new_insurance_premium = 0;
            localApp.model.status = 1;
            localApp.item = localApp.model;
            console.log(response.data.data);
          }
        })
        .catch(function(e) {
          console.log(e);
          // localApp.kick();
        });
    },
    loadLatestPremium: function(id) {
      var localApp = this;
      axios
        .get("/api/insurance/latest_premium/" + id, {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then(function(response) {
          let data = response.data.data;
          if (data !== null) {
            localApp.model.coverage = data.coverage;
            localApp.model.insurance_premium = data.premium;
          }
        })
        .catch(function() {
          localApp.kick();
        });
    },
  },
  computed: {
    calculateDateDiff() {
      if (this.model.cover_end_date !== "") {
        let timeDiff = Math.abs(
          moment(this.model.cover_start_date, "YYYY-MM-DD HH:MM") -
            moment(this.model.cover_end_date, "YYYY-MM-DD HH:MM")
        );
        let dateDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));
        return dateDiff;
      } else return "";
    },
    formattedStartCoverDate: {
      get: function() {
        return this.date2;
      },
      set: function(newValue) {
        let isFirstSlashSet2 = false;
        let isSecondSlashSet2 = false;

        if (newValue.length > 10) {
          this.model.cover_start_date = newValue.substr(0, 10);
        } else {
          if (newValue.length === 2 && !isFirstSlashSet2) {
            isFirstSlashSet2 = true;
            newValue += "/";
          }
          if (newValue.length === 5 && !isSecondSlashSet2) {
            isSecondSlashSet2 = true;
            newValue += "/";
          }
          if (newValue.length === 6) {
            isSecondSlashSet2 = false;
            isSecondSlashSet2 = false;
          }
          this.date2 = newValue;
          this.model.cover_start_date = moment(newValue, "DD/MM/YYYY")
            .add(-543, "y")
            .format("YYYY-MM-DD HH:MM");
        }
      },
    },
    formattedEndCoverDate: {
      get: function() {
        return this.date3;
      },
      set: function(newValue) {
        let isFirstSlashSet3 = false;
        let isSecondSlashSet3 = false;

        if (newValue.length > 10) {
          this.model.cover_end_date = newValue.substr(0, 10);
        } else {
          if (newValue.length === 2 && !isFirstSlashSet3) {
            isFirstSlashSet3 = true;
            newValue += "/";
          }
          if (newValue.length === 5 && !isSecondSlashSet3) {
            isSecondSlashSet3 = true;
            newValue += "/";
          }
          if (newValue.length === 6) {
            isSecondSlashSet3 = false;
            isSecondSlashSet3 = false;
          }
          this.date3 = newValue;
          this.model.cover_end_date = moment(newValue, "DD/MM/YYYY")
            .add(-543, "y")
            .format("YYYY-MM-DD HH:MM");
        }
      },
    },
  },
  watch: {
    "model.province": function(newVal) {
      this.selectProvince(newVal, -1);
    },
    "model.district": function(newVal) {
      this.selectDistrict(newVal, -1);
    },
    "model.sub_district": function(newVal) {
      this.selectSubDistrict(newVal, -1);
    },
  },
  created: function() {
    if (!localStorage.token) {
      this.kick();
    } else {
      this.getProvince();
      this.getBrand();
      this.getCarCode();
      this.getBodyType();
      this.getAgent();
      this.getCompany();
      this.getInsuranceType();

      if (this.$route.params.id) {
        this.loadInsurance();
      }
    }
  },
};
</script>
<style>
.b-red {
  border: 1px solid red;
}
.b-red:focus {
  border: 1px solid red;
}
h4 {
  color: #525f7f;
  font-size: 0.875rem;
  font-weight: 600;
}
.dropdown .car-code .dropdown-toggle {
  max-width: 200px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.dropdown-menu {
  max-height: 300px !important;
  overflow-y: auto;
}

label,
.form-control,
.btn {
  font-size: 1rem !important;
}

h3 {
  font-size: 1.2rem;
}

.vue-suggestion .vs__list {
  width: 100%;
  z-index: 99999;
  text-align: left;
  border: none;
  border-top: none;
  max-height: 400px;
  overflow-y: auto;
  border-radius: 8px;
  position: relative;
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}
.vue-suggestion .vs__list .vs__list-item {
  background-color: #fff;
  padding: 10px;
}
.vue-suggestion .vs__list .vs__list-item:last-child {
  border-bottom: none;
}
.vue-suggestion .vs__list .vs__list-item:hover {
  background-color: #eee !important;
}
.vue-suggestion .vs__list,
.vue-suggestion .vs__loading {
  position: absolute;
}
.vue-suggestion .vs__list .vs__list-item {
  cursor: pointer;
}
.vue-suggestion .vs__list .vs__list-item.vs__item-active {
  background-color: #f3f6fa;
}
.vs__selected {
  margin: 0;
  padding: 0;
  border: 0;
  background-color: #fff;
}
.vs__selected input,
.vs__selected input:focus {
  border: 0;
  outline: none;
  width: 100%;
}
::placeholder {
  color: #8898aa;
}
</style>
